import React, { memo } from 'react'
import { useTranslate } from 'react-admin'

const PriceUnavailable = memo(() => {
  const translate = useTranslate()
  return <div className="small">{translate('Item Not Stocked')}</div>
})

export default PriceUnavailable
